import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["accordion", "activeKey", "className", "children", "defaultActiveKey", "onSelect", "style", "clsPrefix", "bordered", "ghost", "expandIconPosition"];

var _dec, _class;

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.assign.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { createChainedFunction } from '../../wui-core/src';
import Collapse from './Panel';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  //是否是手风琴效果
  accordion: PropTypes.bool,
  //激活的项
  activeKey: PropTypes.any,
  //默认的激活的项
  defaultActiveKey: PropTypes.any,
  //选中函数
  onSelect: PropTypes.func,
  role: PropTypes.string,
  bordered: PropTypes.bool,
  ghost: PropTypes.bool,
  expandIconPosition: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
var defaultProps = {
  accordion: false,
  bordered: false,
  ghost: false,
  expandIconPosition: 'left',
  activeKey: null,
  defaultActiveKey: null,
  className: '',
  style: {},
  onSelect: null
}; // TODO: Use uncontrollable.

var CollapseGroup = (_dec = WebUI({
  name: "collapse-group",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(CollapseGroup, _React$Component);

  var _super = _createSuper(CollapseGroup);

  function CollapseGroup(props, context) {
    var _this;

    _classCallCheck(this, CollapseGroup);

    _this = _super.call(this, props, context);
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    _this.state = {
      activeKey: props.defaultActiveKey
    };
    return _this;
  }

  _createClass(CollapseGroup, [{
    key: "handleSelect",
    value: function handleSelect(key, e) {
      e.preventDefault();

      if (this.props.onSelect) {
        this.props.onSelect(key, e);
      }

      if (this.state.activeKey === key) {
        key = null;
      }

      this.setState({
        activeKey: key
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          accordion = _this$props.accordion,
          propsActiveKey = _this$props.activeKey,
          className = _this$props.className,
          children = _this$props.children,
          defaultActiveKey = _this$props.defaultActiveKey,
          onSelect = _this$props.onSelect,
          style = _this$props.style,
          clsPrefix = _this$props.clsPrefix,
          bordered = _this$props.bordered,
          ghost = _this$props.ghost,
          expandIconPosition = _this$props.expandIconPosition,
          others = _objectWithoutProperties(_this$props, _excluded);

      var activeKey;

      if (accordion) {
        activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
        others.role = others.role || 'tablist';
      }

      var classes = {};
      classes["".concat(clsPrefix)] = true;
      return /*#__PURE__*/React.createElement("div", _extends({}, others, {
        className: classNames(className, classes),
        style: this.props.style
      }), React.Children.map(children, function (child) {
        if (! /*#__PURE__*/React.isValidElement(child)) {
          return child;
        }

        var paneKey = child.key === null ? child.props.eventKey : child.key;
        var childProps = {
          style: child.props.style,
          bordered: bordered,
          ghost: ghost,
          expandIconPosition: expandIconPosition,
          headerRole: 'tab',
          panelRole: 'tabpanel',
          collapsible: true,
          eventKey: paneKey,
          defaultActiveKey: defaultActiveKey,
          onSelect: createChainedFunction(_this2.handleSelect, child.props.onSelect)
        };

        if (accordion) {
          Object.assign(childProps, {
            headerRole: 'tab',
            panelRole: 'tabpanel',
            collapsible: true,
            expanded: paneKey === activeKey
          });
        }

        return /*#__PURE__*/cloneElement(child, childProps);
      }));
    }
  }]);

  return CollapseGroup;
}(React.Component)) || _class);
CollapseGroup.propTypes = propTypes; // CollapseGroup.defaultProps = defaultProps;

CollapseGroup.Panel = Collapse;
export default CollapseGroup;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-collapse/src/Collapse.js